import React, { useContext, useState } from 'react';

import PinMapProvider from './PinMapProvider';
import PinMapInterface from './PinMapInterface';

const PinMap = () => {

  return (
    <PinMapProvider>
      <PinMapInterface />
    </PinMapProvider>
  );
}

export default PinMap;